export const SOURCE_DOMAIN_CH = "telecharger.vivatax.ch" as const;
export const SOURCE_DOMAIN_FR = "telecharger.vivatax.fr" as const;

export type SourceDomain =
  | typeof SOURCE_DOMAIN_CH
  | typeof SOURCE_DOMAIN_FR;

function isSourceDomain(value: unknown): value is SourceDomain {
  return value === SOURCE_DOMAIN_CH || value === SOURCE_DOMAIN_FR;
}

export function detectSourceDomain(
  hostname: string,
  localOverride = import.meta.env.VITE_SOURCE_DOMAIN,
): SourceDomain | null {
  const normalizedHostname = hostname.trim().toLowerCase();
  if (isSourceDomain(normalizedHostname)) return normalizedHostname;

  if (
    normalizedHostname === "localhost" ||
    normalizedHostname === "127.0.0.1"
  ) {
    return isSourceDomain(localOverride) ? localOverride : SOURCE_DOMAIN_CH;
  }

  return null;
}
